const MANAGEMENT_COMPANIES_PERMISSIONS = {
	WORKFORCE_ACTION_VIEW: 'WORKFORCE_PAGE.ACTION.VIEW',
	REOPEN_CANCELLED_SLOT: 'GLOBAL_CALENDAR_VIEW.FLEX_SHIFTS.ACTION.REOPEN',
	WORKFORCE_PROFESSIONAL_EDIT: 'WORKFORCE_PAGE.PROFESSIONAL.EDIT',
	WORKFORCE_PROFESSIONAL_VIEW: 'WORKFORCE_PAGE.PROFESSIONAL.PROFILE.VIEW',
	FACILITY_FLEX_FLOAT: 'FACILITY.FLEX_SHIFTS.ACTION.FLOAT',
	FACILITY_ON_DEMAND_FLOAT: 'FACILITY.ON_DEMAND_SHIFTS.ACTION.FLOAT',
	SETTINGS_PAGE_VIEW: 'SETTINGS.PAGE.VIEW',
	PORTAL_CREATE_FLEX_PAST_SHIFTS: 'PORTAL.FLEX.CREATE_PAST_SHIFTS',
	FLEX_SPLIT_SHIFT: 'FLEX_SHIFTS.ACTION.SPLIT',
	PORTAL_ADD_FLEX_PROFESSIONAL: 'PORTAL.FLEX.ADD_PROFESSIONAL',
	PORTAL_EDIT_FLEX_PROFESSIONAL: 'PORTAL.FLEX_PROFESSIONAL.EDIT',
	EMPLOYEE_IDS_EDIT: 'WORKFORCE.EMPLOYEE.EMPLOYEE_IDS.EDIT'
};

export default MANAGEMENT_COMPANIES_PERMISSIONS;
